import { render, staticRenderFns } from "./ContentSections.vue?vue&type=template&id=88d8428c&"
import script from "./ContentSections.vue?vue&type=script&lang=js&"
export * from "./ContentSections.vue?vue&type=script&lang=js&"
import style0 from "./ContentSections.vue?vue&type=style&index=0&id=88d8428c&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionTitleText: require('/codebuild/output/src1293878547/src/biennale/components/section/TitleText.vue').default,SectionImageText: require('/codebuild/output/src1293878547/src/biennale/components/section/ImageText.vue').default,SectionImageFullScreen: require('/codebuild/output/src1293878547/src/biennale/components/section/ImageFullScreen.vue').default,SectionPhotographer: require('/codebuild/output/src1293878547/src/biennale/components/section/Photographer.vue').default,SectionImageGrid: require('/codebuild/output/src1293878547/src/biennale/components/section/ImageGrid.vue').default,SectionVideo: require('/codebuild/output/src1293878547/src/biennale/components/section/Video.vue').default})
